import React, { useState } from 'react';
import { Box, Button, Modal, Text } from '@rsos/base-components';
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@rsos/base-components/Modal/ModalComponents';

export type ConfirmationModalProps = {
  action: () => void;
  title?: string;
  bodyText?: string;
  doItText?: string;
  cancelText?: string;
  children: (opts: { confirm: () => void }) => React.ReactNode;
};

export const ConfirmationModal = ({
  action,
  title = 'Confirmation',
  bodyText = 'Are you sure?',
  doItText = 'Yes',
  cancelText = 'Cancel',
  children,
}: ConfirmationModalProps) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      {children({
        confirm: () => {
          setOpen(true);
        },
      })}
      <Modal
        id={'confirm'}
        portalPriority={2}
        isOpened={open}
        onClose={close}
        minHeight="100px"
      >
        <ModalHeader onClose={close}>
          <Text size="header" color="primaryText" fontWeight="semibold">
            {title}
          </Text>
        </ModalHeader>
        <ModalBody width={350}>
          <Text mb={16} color="secondaryText">
            {bodyText}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Box horizontal grow>
            <Button
              onClick={() => {
                action();
                close();
              }}
              btnType="warning_primary"
              type="button"
              size="large"
              m={0}
              grow
            >
              {doItText}
            </Button>
            <Button
              onClick={close}
              size="large"
              btnType="tertiary"
              type="button"
              grow
              m={0}
              ml="16px"
            >
              {cancelText}
            </Button>
          </Box>
        </ModalFooter>
      </Modal>
    </>
  );
};
